// Tag component for displaying tags
import { Tag as TagType } from '@types';
import { cn } from '@utils/classNames';
import { TAG_COLORS } from '@config/constants';

interface TagProps {
  tag: TagType;
  className?: string;
}

export const Tag: React.FC<TagProps> = ({ tag, className }) => {
  const bgColor = TAG_COLORS[tag.type] || TAG_COLORS.category;
  
  // Erstelle einen Gradient-Effekt für grüne Tags
  const isGreenTag = (tag.color || bgColor).includes('30d8') || (tag.color || bgColor).includes('30d870');
  
  return (
    <div
      className={cn(
        'inline-flex items-center justify-center h-[19px] px-2 rounded-[5px]',
        'opacity-90 transition-all hover:opacity-100 hover:scale-105',
        isGreenTag && 'shadow-sm shadow-primary/30 border border-primary/20',
        className
      )}
      style={{ 
        background: isGreenTag 
          ? 'linear-gradient(135deg, #30d870 0%, #00ff61 100%)' 
          : tag.color || bgColor 
      }}
    >
      <span className="text-xs font-inter font-bold text-black whitespace-nowrap drop-shadow-sm">
        {tag.label}
      </span>
    </div>
  );
};




